export default {
  'nav.home': '홈',
  'nav.career': '변호사 소개',
  'nav.practice': '수행사건',
  'nav.contact': '상담문의',
  'hero.title': '대전이혼전문변호사',
  'hero.subtitle': '신가영 변호사',
  'hero.tagline': '의뢰인들의 언니, 누나, 친구, 딸 같은, 누구나 가까이 다가갈 수 있는 친절하고 친근한 이혼전문변호사',
  'hero.cta.call': '전화 상담',
  'hero.cta.booking': '네이버 예약',
  'career.title': '학력 및 경력사항',
  'career.education': '학력',
  'career.career': '경력',
  'practice.title': '주요 수행사건',
  'practice.subtitle': '신가영 대전이혼전문변호사가 전문적으로 수행하는 사건입니다',
  'guardian.title': '대전가정법원 전문성년후견인으로 활동',
  'guardian.subtitle': '상속, 성년후견 등 다양한 가사사건에 대한 경험을 가진 변호사입니다',
  'guardian.desc': '관련 사건으로 상속재산분할협의, 한정승인, 성년후견의 경험이 있어 가사사건에 다양하게 수반되는 관련 법적 문제들을 종합적으로 해결하고 모색하는 능력이 출중합니다.',
  'why.title': '신가영 변호사를 선택해야 하는 이유',
  'why.subtitle': '대전이혼전문변호사 신가영 변호사만의 강점',
  'faq.title': '자주 묻는 질문',
  'faq.subtitle': '대전이혼전문변호사에게 가장 많이 문의하는 질문을 모았습니다',
  'contact.title': '상담문의',
  'contact.subtitle': '이혼이나 각종 송사를 맡기는 것은 한 사람의 일생에서 한 번일까 말까 한 큰 일입니다. 신가영 변호사가 단순한 소송의 승패를 떠나 의뢰인들의 삶의 한 챕터를 마무리하는 동반자와 같은 조력자가 되겠습니다.',
  'contact.office': '사무실',
  'contact.mobile': '변호사 직통',
  'contact.address': '주소',
  'contact.blog': '유튜브',
  'contact.booking': '네이버 예약',
  'footer.copyright': '신가영 법률사무소. All rights reserved.',
  'footer.keyword': '대전이혼전문변호사',
  'press.title': '언론 보도',
  'press.subtitle': '신가영 대전이혼전문변호사 관련 보도 기사',
};